import { Link } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css"; // this is required by gallery

export default function BreadA() {
  const names = [
    "Acis1.JPG", "Acis2.JPG", "Acis3.JPG",
    //"Acis4.JPG", 
    "Acis_KilmesDokumentas.jpg",
    "Amber1.JPG", "Amber2.JPG",
    //"Amber3.JPG","Amber4.JPG", 
    "Amber_KilmesDokumentas.jpg",
    //"Amzis1.JPG",
    "Amzis2.JPG", "Amzis3.JPG", "Amzis4.JPG", "Amzis_KilmesDokumentas.jpg",
    //"Argo1.JPG","Argo2.JPG",
    "Argo3.JPG", "Argo4.JPG", "Argo_KilmesDokumentas.jpg"];
  let images = [];
  for (const name of names) {
    images.push({
      original: `photos/breed-a/${name}`,
      thumbnail: `photos/breed-a/small${name}`
    })
  }

  return (
    <div>

      <div className="container">
        <div className="row center">
          <h2 className="header col s12 light">A vada</h2>
          <p className="headline light">Viena kalytė ir trys patinėliai. 2018 metų sausio 7 dieną.</p>
        </div>
        <div className="row">
          <div className="col m12 xl6 left">
            <div className="row">
              <h5 className=""><Link to="/about-chika">CHIHA MANO AREKA (ČIKA)</Link></h5>
              <Link to="/about-chika" ><img className="container-image" src="/photos/breed-a/chika.jpg" title="Cika Bostono Terjeras" alt="bostono-terjeras-cika"></img></Link>

            </div>
            <div className="row">
              <ul className="with-icons">
                <li>Kandidatas į tarptautinius čempionus</li>
                <li>Kandidatas į šalies čempionus</li>
                <li>Klubo nugalėtojas</li>
                <li>Visose parodose teisėjų įvertinimas- puikiai</li>
              </ul>
              <a href="/docs/0327_001.pdf" target="_blank" rel="noopener noreferrer">Kilmės dokumentas.</a>
              <br />
              <a href="/docs/0326_001.pdf" target="_blank" rel="noopener noreferrer">Kelio sąnarių klinikinio įvertinimo sertifikatas. (patella 0/0)</a>
              <br />
              <a href="/docs/0328_001.pdf" target="_blank" rel="noopener noreferrer">Akių tyrimo dokumentas.</a>

            </div>
          </div>
          <div className="col m12 xl6 left">
            <div className="row">
              <h5 className="">AS'GUNAPAL WELCOME WINNER</h5>
              <img className="container-image" src="/photos/breed-a/asgunapal.jpg" title="ASGUNAPAL WELCOME WINNER Bostono Terjeras" alt="bostono-terjeras-asgunapal"></img>
            </div>
            <div className="row">
              <ul className="with-icons">
                <li>Tarptautinis čempionas</li>
                <li>Baltijos čempionas</li>
                <li>Baltijos jaunimo čempionas</li>
                <li>Rusijos čempionas</li>
                <li>Rusijos kinologų federacijos čempionas</li>
                <li>Rusijos jaunimo čempionas</li>
                <li>Baltarusijos didysis čempionas (Grand Champion)</li>
                <li>Baltarusijos čempionas</li>
                <li>Lietuvos čempionas</li>
                <li>Lietuvos jaunimo čempionas</li>
                <li>Latvijos čempionas</li>
                <li>Latvijos jaunimo čempionas</li>
                <li>Estijos čempionas</li>
                <li>Estijos jaunimo čempionas</li>

              </ul>
              <a href="/docs/asgunapal.pdf" target="_blank" rel="noopener noreferrer">Kilmės dokumentas.</a>
            </div>

          </div>
        </div>

      </div>

      <div className="container">
        <div className="row center">
          <h2>Šuniukų galerija</h2>
        </div>
        <div className="row center">
          <ImageGallery items={images} slideInterval={2000} />
        </div>
      </div>

    </div>
  );

}
